import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 全局引入
import CImage from "./components/pc/CImage.vue";

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.component("CImage", CImage);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

document.title = "领航金（绵阳）珠宝饰品有限责任公司";
